const languageList = {
  tijneyewear: [
    {
      label: "Global",
      value: "all"
    },
    {
      label: "Japan",
      value: "ja"
    }
  ]
};

export default languageList;
